import Header from "@editorjs/header";
import InlineCode from "@editorjs/inline-code";
import Checklist from "@editorjs/checklist";
import Delimiter from "@editorjs/delimiter";
import Warning from "@editorjs/warning";
import Marker from "@editorjs/marker";
import { Table } from "./table";
import { NestedList } from "./nested-list";
import { Quote } from "./quote";
import { Code } from "./code";
import { Note } from "./note";
import { Embed } from "./embed";
import { Fillin } from "./fillin";
import { RockImage } from "./rockimage";

export const EditorTools = {
    Header,
    InlineCode,
    NestedList,
    Checklist,
    Quote,
    Code,
    Note,
    Delimiter,
    Warning,
    Marker,
    Table,
    Embed,
    Fillin,
    RockImage
};
